
import { useStoreInNodes } from '@/composables/useStoreInNodes';
import { ClearAddingNode } from '@/constants/actions.js';

export default {
  props: {
    icon: { type: String, default: '' },
    text: { type: String, default: 'Preview' },
    darkMode: { type: Boolean, default: false },
  },

  setup() {
    const { store } = useStoreInNodes();

    const onCancel = () => store.value.dispatch(`builderStore/${ClearAddingNode}`);

    return {
      onCancel,
    };
  },
};
